<template>
  <div class="help">
    <div class="help-banner ">
      <div >
        <p>帮助中心</p>
        <p>蓝凌智能OA帮助手册，找到您所需要的答案</p>
      </div>
    </div>
    <div class="newwrap">
          <p>新手指南</p>
      <div class="new">
        <div class="new-handimg">
          <img src="../assets/help/hand.png" alt />
        </div>
        <div class="new-help">
          <ul >
            <li @mouseenter="changeActive($event)"  @mouseleave="removeActive($event)" @click="setDotted(0)">
              <a @click="toLogin()">
                <img src="../assets/help/newhand1.png" alt />
                <span>如何立即体验蓝凌智能OA</span>
              </a>
              <div class="new-help-more">
              </div>
            </li>
            <li @mouseenter="changeActive($event)"  @mouseleave="removeActive($event)" @click="setDotted(1)">
              <a href="http://faq.dingteam.com/docs/mindoc/buy">
                <img src="../assets/help/newhand2.png" alt />
                <span>如何购买蓝凌智能OA</span>
              </a>
              <div class="new-help-more">
              </div>
            </li>
          </ul>
          <ul >
            <li @mouseenter="changeActive($event)"  @mouseleave="removeActive($event)" @click="setDotted(2)">
              <a class="new-help-icon" href="http://faq.dingteam.com/docs/mindoc/register">
                <img src="../assets/help/newhand3.png" alt />
                <span class="new-help-tips">如何登录蓝凌智能OA</span>
              </a>
              <div class="new-help-more">
              </div>
            </li>
            <li @mouseenter="changeActive($event)"  @mouseleave="removeActive($event)" @click="setDotted(3)">
              <a href="http://faq.dingteam.com/docs/mindoc/mindoc-1bhstm119k21a">
                <img src="../assets/help/newhand4.png" alt />
                <span>蓝凌智能OA能帮到你什么？</span>
              </a>
              <div class="new-help-more">
              </div>
            </li>
          </ul>
          <ul >
            <li @mouseenter="changeActive($event)"  @mouseleave="removeActive($event)" @click="setDotted(4)">
              <a href="https://tms.dingtalk.com/markets/dingtalk/download?spm=a3140.8736650.2231602.9.517c5c8coj7u5y&source=1121&lwfrom=2017120202092064213045801">
                <img src="../assets/help/newhand5.png" alt />
                <span>如何下载钉钉客户端</span>
              </a>
              <div class="new-help-more">
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="usewrap">
      <div class="use">
        <p class="title">使用指南</p>
        <p class="tips">功能模块说明</p>
      </div>
      <ul class="use-list">
        <li v-for="(item,index) in useList" :key="index" @click="goGuide(item.url)">
          <img :src="item.icon" alt />
          <p>{{item.name}}</p>
        </li>
      </ul>
      <div class="know-more point" @click="goMore">
        <span href="http://faq.dingteam.com/docs/mindoc/mindoc-1bdnqkkrjcbje">了解更多</span>
      </div>
    </div>
    <div class="use question">
      <p class="title">常见问题</p>
      <p class="tips">FAQ</p>
      <ul>
        <li v-for="(item,index) in questionList" :key="index" @click="goGuide(item.url)">
          <span></span>
          {{item.text}}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import use1 from "../assets/help/1.png";
// import use2 from "../assets/help/2.png";
import use3 from "../assets/help/3.png";
// import use4 from "../assets/help/4.png";
import use5 from "../assets/help/5.png";
import use6 from "../assets/help/6.png";
import use7 from "../assets/help/7.png";
import use8 from "../assets/help/8.png";
import use9 from "../assets/help/9.png";
import use10 from "../assets/help/10.png";
import use11 from "../assets/help/11.png";
import use12 from "../assets/help/12.png";
import use13 from "../assets/help/13.png";
import use14 from "../assets/help/14.png";
import use15 from "../assets/help/15.png";
import use16 from "../assets/help/16.png";
import use17 from "../assets/help/17.png";
import use18 from "../assets/help/18.png";
export default {
  data() {
    return {
      useList: [
        {
          icon: use1,
          name: "审批",
          url:'http://faq.dingteam.com/docs/mindoc/mindoc-1bg6pdhjq2svq'
        },
        // {
        //   icon: use2,
        //   name: "报销",
        //   url:''
        // },
        // {
        //   icon: use4,
        //   name: "考勤"
        // },
        {
          icon: use5,
          name: "客户",
          url:'http://faq.dingteam.com/docs/mindoc/mindoc-1bg9bo4d63sr6'
        },

        {
          icon: use6,
          name: "商机",
          url:'http://faq.dingteam.com/docs/mindoc/mindoc-1bg9bod2cej6d'
        },
        {
          icon: use7,
          name: "合同",
          url:'http://faq.dingteam.com/docs/mindoc/mindoc-1bg9bojq2fpj0'
        },
        {
          icon: use8,
          name: "收款",
          url:'http://faq.dingteam.com/docs/mindoc/mindoc-1bg9bp13aa824'
        },
        {
          icon: use9,
          name: "报表",
          url:'http://faq.dingteam.com/docs/mindoc/mindoc-1bg9bp6jnou17'
        },
        {
          icon: use10,
          name: "文档",
          url:'http://faq.dingteam.com/docs/mindoc/mindoc-1bhsub0uebucn'
        },
        {
          icon: use11,
          name: "日程",
          url:'http://faq.dingteam.com/docs/mindoc/mindoc-1bg72b5isdgsd'
        },
        {
          icon: use12,
          name: "任务管理",
          url:'http://faq.dingteam.com/docs/mindoc/mindoc-1bg7394jih07d'
        },
        {
          icon: use13,
          name: "项目管理",
          url:'http://faq.dingteam.com/docs/mindoc/mindoc-1bg72qbhsbl2e'
        },
        {
          icon: use14,
          name: "人事管理",
          url:'http://faq.dingteam.com/docs/mindoc/mindoc-1bge6jer8lt5r'
        },
        {
          icon: use15,
          name: "考试管理",
          url:'http://faq.dingteam.com/docs/mindoc/mindoc-1bhvc9i4lk34q'
        },
        {
          icon: use16,
          name: "车辆管理",
          url:'http://faq.dingteam.com/docs/mindoc/mindoc-1bgbqrfc67r0e'
        },
        {
          icon: use17,
          name: "员工活动",
          url:'http://faq.dingteam.com/docs/mindoc/mindoc-1bg8t8uf0dovr'
        },
        {
          icon: use18,
          name: "投票管理",
          url:'http://faq.dingteam.com/docs/mindoc/mindoc-1bg9a8qaco6pv'
        },
        {
          icon: use3,
          name: "工作报告",
          url:'http://faq.dingteam.com/docs/mindoc/mindoc-1bg6uduc45qb7'
        },
      ],
      questionList: [
        {text:'智能OA(F4)能升级到EKP吗？',url:'http://faq.dingteam.com/docs/mindoc/mindoc-1bhsuu575mttu'},
        {text:'是否可以配置其他自定义功能模块',url:'http://faq.dingteam.com/docs/mindoc/mindoc-1bhsv1jt7qjo3'},
        {text:'怎么开通智能OA体验账号？',url:'http://faq.dingteam.com/docs/mindoc/mindoc-1bhsv2fub073t'},
        {text:'F4和EIS的区别是什么？',url:'http://faq.dingteam.com/docs/mindoc/mindoc-1bhsv3rttnqbr'},
        {text:'F4有英文版吗？',url:'http://faq.dingteam.com/docs/mindoc/mindoc-1bhsv4f50atle'},
        {text:'F4能否买断？',url:'http://faq.dingteam.com/docs/mindoc/mindoc-1bhsv5qqt25nm'},
        {text:'EIS可以和智能OA结合吗？',url:'http://faq.dingteam.com/docs/mindoc/mindoc-1bhv93grr60t1'},
        {text:'财务凭证对接支持金蝶K3的多个版本吗？',url:'http://faq.dingteam.com/docs/mindoc/mindoc-1bhv95o36jf1f'},
        {text:'F4的注册用户数是以钉钉架构人数还是以开出端口人数为准',url:'http://faq.dingteam.com/docs/mindoc/mindoc-1bhv9opdctl0a'},
        {text:'钉钉和蓝凌的客户保护报备会不会冲突？',url:'http://faq.dingteam.com/docs/mindoc/mindoc-1bhv9r85265fg'},
        {text:'代理智能OA要打款吗？蓝凌会提供什么支持？',url:'http://faq.dingteam.com/docs/mindoc/mindoc-1bhv9tghagg84'}
      ]
    };
  },
   mounted() {
    //  this.$nextTick(() => {
    //   this.$scroll.reveal(".d-animated", {
    //     distance: "40px",
    //     delay: 500,
    //     easing: "linear",
    //     opacity: 1,
    //     beforeReveal: function(domEl) {
    //       console.log("动画执行了", domEl);
    //     },
    //   });
    //    // 有延迟效果的动画
    //   this.$scroll.reveal(".d-animated-1", {
    //     distance: "40px",
    //     delay: 400,
    //     easing: "ease"
    //   });
    //   // 有延迟效果的动画
    //   this.$scroll.reveal(".d-animated-2", {
    //     distance: "40px",
    //     delay: 600,
    //     easing: "ease"
    //   });
    //   // 有延迟效果的动画
    //   this.$scroll.reveal(".d-animated-3", {
    //     distance: "40px",
    //     delay: 800
    //   });
    //    // 有延迟效果的动画
    //   this.$scroll.reveal(".d-animated-4", {
    //     distance: "40px",
    //     delay: 1000
    //   });
    //     // 有延迟效果的动画
    //   this.$scroll.reveal(".d-animated-5", {
    //     distance: "40px",
    //     delay: 1200,
    //     easing: "ease"
    //   });
    //    // 有延迟效果的动画
    //   this.$scroll.reveal(".d-animated-6", {
    //     distance: "40px",
    //     delay: 1400,
    //     easing: "ease"
    //   });
    //    // 有延迟效果的动画
    //   this.$scroll.reveal(".d-animated-7", {
    //     distance: "40px",
    //     delay: 1600,
    //     easing: "ease"
    //   });
    // });
  },
  methods:{
      toLogin(){
        this.$root.$emit('change',true)
      },
      goGuide(url){
          window.location.href = url
            _czc.push(["_trackEvent","使用指南", "icon"]);   
      },
      goMore(){
        window.location.href = 'http://faq.dingteam.com/docs/mindoc/mindoc-1bdnqkkrjcbje'
      },
      changeActive(e) {
          e.currentTarget.className = "more-animate"
      },
      removeActive(e) {
          e.currentTarget.className = ""
      },
      setDotted(index) {
        switch (index) {
          case 0 :
            _czc.push(["_trackEvent","新手指南_icon_蓝凌智能OA注册", "icon"]);   
          break;    
          case 1 :
            _czc.push(["_trackEvent","新手指南_icon_如何购买蓝凌智能OA", "icon"]);   
          break;    
          case 2 :
            _czc.push(["_trackEvent","新手指南_icon_蓝凌智能OA登录", "icon"]);   
          break;    
          case 3 :
            _czc.push(["_trackEvent","新手指南_icon_系统主功能介绍", "icon"]);   
          break;         
          case 4 :
            _czc.push(["_trackEvent","新手指南_icon_钉钉客户端下载", "icon"]);   
          break;    
        }
      }
  }
};
</script>

<style lang="less" scoped>
.help {
  min-width: 1200px;
  .title {
    padding-top: 60px;
    padding-bottom: 30px;
    font-size: 28px;
    color: #333333;
  }
  .tips {
    font-size: 16px;
    color: #999999;
    padding-bottom: 40px;
  }
  .help-banner {
    margin-top: 70px;
    height: 380px;
    background: url('../assets/help_bg.png') 0 0 no-repeat;
    background-size:100% 100%;
    display: flex;
    align-items: center;
    > div {
      width: 1200px;
      margin: 0 auto;
      p {
        color:white;
        &:nth-child(1) {
          font-size: 42px;
          text-align: center;
          line-height: 42px;
          margin-bottom: 40px;
        }
        &:nth-last-child(1) {
          font-size: 20px;
          text-align: center;
          line-height: 20px;
        }
      }
    }
  }
  .newwrap {
    background-image: linear-gradient(0deg, #ffffff 32%, #fafbfc 100%);
         >p {
          font-size: 28px;
          color: #333333;
          text-align: center;
          line-height: 28px;
          padding-top: 120px;
          padding-bottom: 30px;
          width:1200px;
          margin:0 auto;
        }
    .new {
      width: 1200px;
      height: 400px;
      margin: 0 auto;
        position: relative;
      .new-handimg {
        display: inline-block;
        height:100%;
        width:400px;
        img {

        width:400px;
        }
      }
      .new-help {
        padding-right: 95px;
        display: inline-block;
        position:absolute;
        left:400px;
        top:-5px;
        ul {
          display: flex;
          justify-content: space-between;
          margin-top: 50px;
            li {
            font-size: 18px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: #333333;
            width:320px;
            cursor: pointer;
            &:nth-child(2n+1) {
                margin-right: 83px;
            }
            img {
              width: 45px;
              height: 45px;
              vertical-align: middle;
            }
            span {
              margin-left: 10px;
              color:#000;
            }
            .new-help-more {
                width:14px;
                height:14px;
                background:url('../assets/help/gray-arrows.png') top right no-repeat;
                background-size: 16px;
                margin-right:10px;
            }
          }
            .more-animate {
                // color:#4285f4;
                a{
                  color: #4285f4;
                }
                .new-help-more{
                    background:url('../assets/decorate/arrows.png') top right no-repeat;
                    background-size: 16px;
                    animation: move 0.2s forwards;
                }
            }
        }
      }
    }
  }
  .usewrap {
    background-image: linear-gradient(0deg, #ffffff 32%, #fafbfc 100%);
    .use {
      width: 1200px;
      margin: 0 auto;
      text-align: center;
    }
    .use-list {
      display: flex;
      flex-wrap: wrap;
      padding: 0 60px;
      width:1200px;
      margin:0 auto;
      li {
        width: 180px;
        text-align: center;
        &:hover{
          cursor: pointer;
          p{
            color:#4285f4;
          }
        }
      }
      img {
        width: 70px;
        height: 70px;
        vertical-align: bottom;
      }
      p {
        text-align: center;
        margin-top: 20px;
        margin-bottom: 40px;
        font-size: 14px;
        color: #333333;
      }
    }
  }
  .know-more {
    width: 1200px;
    margin: 0 auto;
    text-align: center;
    margin-top: 60px;
    padding-bottom: 100px;
    span {
      display: inline-block;
      background: #ffffff;
      border: 1px solid #4285f4;
      border-radius: 21px;
      width: 126px;
      height: 42px;
      line-height: 42px;
      font-size: 16px;
      color: #4285f4;
      text-shadow: 0 2px 17px rgba(255, 255, 255, 0.13);
      &:hover{
        animation: bganimate 0.5s forwards;
        color:white;
        border:none;
      }
    }
  }
  .question {
    width: 1200px;
    margin: 0 auto;
    text-align: center;
    ul {
      padding-left: 170px;
      display: flex;
    //   justify-content: space-between;
      flex-wrap: wrap;
      padding-bottom:90px;
      li {
        width: 422px;
        text-align: left;
        font-size: 14px;
        color: #333333;
        line-height: 14px;
      margin-bottom:30px;
      cursor: pointer;
        &:nth-child(2n+1) {
        margin-right: 75px;            
        }
        &:hover{
          color:#4285f4;
        }
      }
      span {
        display: inline-block;
        width: 8px;
        height: 8px;
        background: #e3e3e3;
        border-radius: 2px;
        margin-right: 17px;
      }
    }
  }
}
@keyframes move {
    0%{
        margin-right:10px;
    }
    100%{
        margin-right:0;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/help.vue